import * as yup from 'yup';

export const addPropertyValidation = yup.object({
  category: yup.string().required('*required'),
  price: yup.string().required('*required'),
  type: yup.string().required('*required'),
  noOfRooms: yup.string().test('noOfRooms', '*required', (value, context) => {
    if (context.parent.type === 'Land') {
      return true;
    }
    return !!value;
  }),
  noOfBath: yup.number().test('noOfBath', '*required', (value, context) => {
    if (context.parent.type === 'Land') {
      return true;
    }
    return !!value;
  }),
  roomSize: yup
    .number()
    .test('roomSize', '*required', (value, context) => {
      if (context.parent.type === 'Land') {
        return true;
      }
      return !!value;
    })
    .min(1, 'must be greater than or equal to 1'),
  agent: yup
    .object()
    .test('Test agent', 'agent is required', (value) => value?.name),
  description: yup.string().required('*required'),
  title: yup.string().required('*required'),
  inspectionFee: yup.string(),
  landSize: yup.number().test('landSize', '*required', (value, context) => {
    if (context.parent.type === 'Land') {
      return !!value;
    }
    return true;
  }),
  landUnit: yup.string().test('landSize', '*required', (value, context) => {
    if (context.parent.type === 'Land') {
      return !!value;
    }
    return true;
  })
});

export const editPropertyValidation = yup.object({
  category: yup.string(),
  price: yup.string(),
  type: yup.string(),
  noOfRooms: yup.string().test('noOfRooms', '*required', (value, context) => {
    if (context.parent.type.toLowerCase() === 'land') {
      return true;
    }
    return !!value;
  }),
  noOfBath: yup.number().test('noOfBath', '*required', (value, context) => {
    if (context.parent.type.toLowerCase() === 'land') {
      return true;
    }
    return !!value;
  }),
  roomSize: yup.number().test('roomSize', '*required', (value, context) => {
    if (context.parent.type.toLowerCase() === 'land') {
      return true;
    }
    return !!value;
  }),
  landSize: yup.number().test('landSize', '*required', (value, context) => {
    if (context.parent.type.toLowerCase() === 'land') {
      return !!value;
    }
    return true;
  }),
  landUnit: yup.string().test('landSize', '*required', (value, context) => {
    if (context.parent.type.toLowerCase() === 'land') {
      return !!value;
    }
    return true;
  }),
  agent: yup
    .object()
    .test('Test agent', 'agent is required', (value) => value?.name),
  description: yup.string(),
  title: yup.string(),
  inspectionFee: yup.string()
});
